function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 135.869
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M326.44,158.848v194.303c15.892-28.161,28.176-61.46,28.176-97.151S342.332,187.01,326.44,158.848z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M185.56,158.848v194.303c-15.892-28.161-28.176-61.46-28.176-97.151S169.668,187.01,185.56,158.848z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

function Svg029Kenya(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), _ref2, /*#__PURE__*/React.createElement("rect", {
    y: 376.153,
    style: {
      fill: "#496E2D"
    },
    width: 512,
    height: 135.847
  }), /*#__PURE__*/React.createElement("rect", {
    y: 169.906,
    style: {
      fill: "#A2001D"
    },
    width: 512,
    height: 172.199
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "356.897,81.712 318.524,64 256,205.572 193.476,64 155.103,81.712 232.726,256    155.103,430.288 193.476,448 256,306.428 318.524,448 356.897,430.288 279.274,256  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M282.063,98.404C267.208,82.18,256,72.855,256,72.855s-11.208,9.325-26.063,25.549v315.191   C244.792,429.82,256,439.145,256,439.145s11.208-9.325,26.063-25.55V98.404z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M185.56,158.848v194.303c15.697,27.814,34.911,50.612,49.308,65.727V93.122   C220.471,108.236,201.257,131.033,185.56,158.848z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M326.44,158.848c-15.697-27.814-34.911-50.612-49.308-65.726v325.758   c14.397-15.116,33.611-37.914,49.308-65.727V158.848z"
  })), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg029Kenya);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };